

import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class IBRadioButton extends Vue {

	@Prop({ type: String, default: "" })
	readonly title!: string;

	@Prop({ type: Number })
	readonly number!: number;

	@Prop({ type: Boolean, default: false })
	readonly isActive!: boolean;

	@Prop({ type: Boolean, default: false })
	readonly isDisabled!: boolean;
	
	@Prop({ type: Boolean, default: false })
	readonly isHidden?: boolean;

	radioActive(value: Event) {
		this.$emit("click", value);
	}

}

